import { getCmsJourneyPlannerAction } from "../../../Actions/LogicActions/CMSJourneyPlanner/GetCmsJourneyPlannerAction";
import { getCmsJourneyPlannerStationAction } from "../../../Actions/LogicActions/CMSJourneyPlanner/GetCmsJourneyPlannerStationAction";
import { populateSearchForCmsAction } from "../../../Actions/UIActions/Search/PopulateSearchForCmsAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { IPopulateSearchForCmsActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/IPopulateSearchForCmsActionParams";

class JourneyPlannerMenuInitStep extends StepFlow {
    get stepName() { return "JourneyPlannerMenuInit_Step"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on({
                eventName: evtTree.journeyPlannerMenu.Get,
                handler: async ({ }) => {
                    await Promise.allSettled([
                        getCmsJourneyPlannerStationAction.execute(),
                        getCmsJourneyPlannerAction.execute(),
                    ]);
                },
            })
        );

        // Idle while the shuttle Book Now button is commented out in
        // ShuttleCollapseSection (client request); it fires again once restored.
        this.registerEventSubscription(
            _eventBus.on<IPopulateSearchForCmsActionParams, void>({
                eventName: evtTree.journeyPlannerMenu.shuttle.bookNow,
                handler: async ({ data }) => {
                    _eventBus.emit({
                        eventName: "ROUTE_CHANGE",
                        data: `/search`
                    });
                    setTimeout(() => {
                        populateSearchForCmsAction.setParams(data!);
                        populateSearchForCmsAction.execute();
                    }, 500);
                },
            })
        )
    }

    async onExecute(): Promise<void> {
        console.log("JourneyPlannerMenu Init Step Execute...")
        _eventBus.emit({
            eventName: evtTree.journeyPlannerMenu.Get,
        });
    }
}

export const JourneyPlannerMenuInitStepDeclaration = new StepDefinition({
    stepName: "JourneyPlannerMenuInit_Step",
    stepClass: JourneyPlannerMenuInitStep
});
